export class CreateToDo {
  public AccountNumber: string = '';
  public ToDoType: string = '';
  public ToDoRole?: string = '';
  public Comments?: string = '';
}
